<!-- 특수분류 리스트 -->
<template>
	<div class="sp-cate-list">
		<ul>
			<li v-for="(data, idx) in boardListData" v-bind:key="idx">
				<a @click="openTabUrl(data.boardId, data.boardType, data.descriptionUrl)">
					<div class="thum"><img :src="findimage(data)" :alt="data.boardtitle+' 썸네일'" :title="data.boardtitle+' 썸네일'" @error="errorImageHandler"></div>
					<div class="cate-info-box">
						<div class="cate-tit"><h4>{{ data.boardtitle }}</h4></div>
						<div class="cate-info" v-html="data.orgnlBoardDescription"></div>
					</div>
				</a>
			</li>
			<li v-show="isNoBoardData">
				<div class="notice-content">
					<strong>데이터가 존재하지 않습니다.</strong>
				</div>
      		</li>
		</ul>
	</div>
</template>

<script>
import * as api from '@/api/Notice.js'

export default {
	name: 'SpclClsfListItem',

	data () {
		return {
			isNoBoardData: false
		}
	},

	props: {
		boardListData: {
			type: Array,
			required: true
		}
	},

	watch: {
		boardListData: function () {
			if (this.boardListData.length > 0) {
				this.isNoBoardData = false
			} else {
				this.isNoBoardData = true
			}
		}
	},

	methods: {
		// 썸네일
		findimage (data) {
			try {
				let fileGb = ''
				let directoryPath = ''
				for (const fileData of data.attachFileList) {
					fileGb = fileData.fileGb.toLowerCase()
					if (fileGb === '02') {
						if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'stage') {
							if (process.env.VUE_APP_SUBJECT_SERVER.indexOf("localhost") == -1) {
								directoryPath = fileData.orgnlDirectoryPath.replace("/web/mcstmng/source", "/mng");
								directoryPath = process.env.VUE_APP_ADMIN_SERVER_UPLOAD + directoryPath;
							} else {
								directoryPath = fileData.orgnlDirectoryPath;
							}
						} else {
							directoryPath = fileData.directoryPath;
							directoryPath = directoryPath.replace('http:', 'https:');
						}
						
            			return directoryPath;
					}
				}
			} catch (e) {
				return require('@/assets/img/default_thumbnail.png')
			}
			return require('@/assets/img/default_thumbnail.png')
		},

		// 에러 이미지
		errorImageHandler(event) {
      		event.target.src = require('@/assets/img/default_thumbnail.png');
    	},

		// open URL
		async openTabUrl (boardId, boardType, descriptionUrl) {
			window.open(descriptionUrl, "_blank");

			const paramData = {
				boardId: boardId,
				boardType: boardType
			}

			await api.updateBoardHits(paramData)
		},
	}
}
</script>

<style scoped>
.notice-content {
  width: 100%;display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}
</style>
